<template>
  <div class="edit_studioInfo_box">
    <van-form @submit="onSubmit" ref="form" :show-error="false" label-width="90" colon>
      <van-field
          name="name"
          v-model="formData.studioName"
          label="工作室名称"
          maxlength="15"
          show-word-limit
          placeholder="请输入工作室名称"
          :required="true"
          :rules="[{ required: true, message: '请输入工作室名称' }]"
      />
      <van-field
          name="name"
          v-model="formData.studioWechatName"
          label="企业微信昵称"
          maxlength="15"
          show-word-limit
          placeholder="请输入企业微信昵称"
          :required="true"
          :rules="[{ required: true, message: '请输入企业微信昵称' }]"
      />
      <template v-if="formData.subjectType!=1">
        <van-field
            name="name"
            v-model="formData.hospitalName"
            label="医院名称"
            maxlength="15"
            show-word-limit
            placeholder="请输入医院名称"
            :required="true"
            :rules="[{ required: true, message: '请输入医院名称' }]"
        />
        <van-field
            name="name"
            v-model="formData.officialWebsite"
            label="官网"
            maxlength="50"
            show-word-limit
            placeholder="请输入官网"
            @blur="inputOfficialWebsite"
            :error-message="officialWebsiteError"
            :rules="[{ required: false, message: '请输入官网' }]"
        />
        <van-field
            name="name"
            v-model="formData.email"
            label="邮箱"
            @blur="inputEmail"
            maxlength="50"
            show-word-limit
            :error-message="emailError"
            placeholder="请输入邮箱"
            :rules="[{ required: false, message: '请输入邮箱' }]"
        />
      </template>
      <van-field
          name="name"
          v-model="formData.phone"
          label="手机号"
          maxlength="15"
          show-word-limit
          placeholder="请输入手机号"
          :required="false"
          :rules="[{ required: false, message: '请输入手机号' }]"
      />
      <van-field name="studioAvatar" label="工作室头像" :required="true"
                 :rules="[{ required: true, message: '请上传工作室头像' }]">
        <template #input>
          <van-uploader :class="formData.studioAvatar.length>=1?'hide_uploader_icon':''" v-model="formData.studioAvatar"
                        :before-read="beforeRead" :after-read="afterReadStudioAvatar"
                        ref="uploaderStudioAvatar"
                        :max-count="2"
                        :preview-options="previewOptions"
                        :before-delete="delStudioAvatar" accept="image/*">
            <template #preview-cover="scope">
              <div class="re_upload_btn" @click.stop="handleReUpload('uploaderStudioAvatar')">更换</div>
            </template>
          </van-uploader>
        </template>
      </van-field>
      <van-field name="studioWechatQrCode" label="企业微信二维码" :required="true"
                 :rules="[{ required: true, message: '请上传企业微信二维码' }]">
        <template #input>
          <van-uploader :class="formData.studioWechatQrCode.length>=1?'hide_uploader_icon':''"
                        v-model="formData.studioWechatQrCode"
                        :before-read="beforeRead" :after-read="afterReadStudioWechatQrCode"
                        ref="uploaderStudioWechatQrCode"
                        :max-count="2"
                        :before-delete="delStudioWechatQrCode" accept="image/**">
            <template #preview-cover="scope">
              <div class="re_upload_btn" @click.stop="handleReUpload('uploaderStudioWechatQrCode')">更换</div>
            </template>
          </van-uploader>
        </template>
      </van-field>
      <!--      <van-field name="certificationUrls" label="资格证" :required="false"-->
      <!--                 :rules="[{ required: false, message: '请上传资格证' }]">-->
      <!--        <template #input>-->
      <!--          <van-uploader v-model="formData.certificationUrls" :before-read="beforeRead"-->
      <!--                        :after-read="afterReadCertificationUrls"-->
      <!--                        ref="uploaderCertificationUrls"-->
      <!--                        :max-count="5"-->
      <!--                        :before-delete="delCertificationUrls" accept="image/*">-->
      <!--            <template #preview-cover="scope">-->
      <!--            </template>-->
      <!--          </van-uploader>-->
      <!--        </template>-->
      <!--      </van-field>-->
      <van-field
          v-model="formData.personalStrengths"
          name="trackContent"
          rows="6"
          label="个人擅长"
          type="textarea"
          maxlength="500"
          show-word-limit
          placeholder="请输入个人擅长"
          :required="false"
          :rules="[{ required: false, message: '请输入个人擅长' }]"
      />
      <van-field
          v-model="formData.intro"
          name="trackContent"
          rows="6"
          label="个人简介"
          type="textarea"
          maxlength="500"
          show-word-limit
          placeholder="请输入个人简介"
          :required="false"
          :rules="[{ required: false, message: '请输入个人简介' }]"
      />
      <div class="submit_box">
        <van-button type="default" size="small" @click="handleBack">取消</van-button>
        <van-button type="info" size="small" native-type="submit">保存并返回</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import {uploadOther} from '../../../api/index'
import {getStudioInfo, updateStudioInfo, getStaffSchedule} from "@/api/home";
import {formatTime} from "@/hooks/function";

export default {
  props: ['studioId'],
  data() {
    return {
      formData: {
        id: '',
        studioName: '',
        studioWechatName: '',
        phone: '',
        studioAvatar: [],
        studioWechatQrCode: [],
        certificationUrls: [],
        personalStrengths: '',
        intro: '',
        hospitalName: '',
        email: '',
        officialWebsite: '',
      },
      previewOptions: {
        closeable: true,
      },
      emailError: '',
      officialWebsiteError: '',
    }
  },

  methods: {
    async init(id) {
      console.log(3333);
      let {data: detailInfo} = await getStudioInfo({id})
      this.formData = detailInfo
      let studioAvatar = detailInfo.studioAvatar.split(',') || []
      this.formData.studioAvatar = []
      studioAvatar.forEach((item) => {
        this.formData.studioAvatar.push({'url': item})
      })
      let studioWechatQrCode = detailInfo.studioWechatQrCode.split(',') || []
      this.formData.studioWechatQrCode = []
      studioWechatQrCode.forEach((item) => {
        this.formData.studioWechatQrCode.push({'url': item})
      })
      let certificationUrls = detailInfo.certificationUrls == null ? [] : detailInfo.certificationUrls?.split(',')
      this.formData.certificationUrls = []
      certificationUrls?.forEach((item) => {
        this.formData.certificationUrls.push({'url': item})
      })
      console.log(this.formData, 'formData');
    },
    beforeRead(file) {
      console.log(file, 'file');
      if (!/^image\/(png|jpg|jpeg|webp)$/.test(file.type)) {
        this.$notify("图片格式不符，请重新上传")
        return false;
      }
      if (file.size > 5242880) {
        this.$notify("图片不可大于5M，请重新上传")
        return false;
      }
      return true;
    },
    inputEmail() {
      if (this.formData.email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.formData.email)) {
          this.emailError = "请输入正确格式邮箱";
          return false
        } else {
          this.emailError = "";
        }
      }
    },
    inputOfficialWebsite() {
      if (this.formData.officialWebsite) {
        const websiteRegex = /^(http:\/\/|https:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?(\/\S*)?$/;

        if (!websiteRegex.test(this.formData.officialWebsite)) {
          this.officialWebsiteError = "请输入正确格式官网";
          return false
        } else {
          this.officialWebsiteError = "";
        }
      }


    },
    // 工作室上传图片
    afterReadStudioAvatar(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      let formData = new FormData()
      formData.append('file', file.file)
      formData.append('module', 'efficacy')
      formData.append('category', 'track')
      uploadOther(formData).then(res => {
        if (res.code == 0) {
          setTimeout(() => {
            file.status = 'success';
            file.message = ''
            file.url = res.data.absoluteUrl
          }, 300)
          if (this.formData.studioAvatar.length > 1) {
            this.formData.studioAvatar[0] = this.formData.studioAvatar[1]
            this.formData.studioAvatar.splice(1, 1)
          }
        }

      }).catch((err) => {
        file.status = 'failed';
        file.message = '上传失败';
        this.formData.studioAvatar.splice(1, 1)
      });
    },
    // 企业微信二维码
    afterReadStudioWechatQrCode(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      let formData = new FormData()
      formData.append('file', file.file)
      formData.append('module', 'efficacy')
      formData.append('category', 'track')
      uploadOther(formData).then(res => {
        if (res.code == 0) {
          setTimeout(() => {
            file.status = 'success';
            file.message = ''
            file.url = res.data.absoluteUrl
          }, 300)
          if (this.formData.studioWechatQrCode.length > 1) {
            this.formData.studioWechatQrCode[0] = this.formData.studioWechatQrCode[1]
            this.formData.studioWechatQrCode.splice(1, 1)
          }
        }

      }).catch((err) => {
        file.status = 'failed';
        file.message = '上传失败';
        this.formData.studioWechatQrCode.splice(1, 1)
      });
    },
    // 资格证书
    afterReadCertificationUrls(file) {
      file.status = 'uploading';
      file.message = '上传中...';
      let formData = new FormData()
      formData.append('file', file.file)
      formData.append('module', 'efficacy')
      formData.append('category', 'track')
      uploadOther(formData).then(res => {
        if (res.code == 0) {
          setTimeout(() => {
            file.status = 'success';
            file.message = ''
            file.url = res.data.absoluteUrl
          }, 300)
        }

      }).catch((err) => {
        file.status = 'failed';
        file.message = '上传失败';
      });
    },
    // 删除图片
    delStudioAvatar(item) {
      this.formData.studioAvatar = this.formData.studioAvatar.filter(v => v.url != item.url)
    },
    // 删除图片
    delStudioWechatQrCode(item) {
      this.formData.studioWechatQrCode = this.formData.studioWechatQrCode.filter(v => v.url != item.url)
    },
    // 删除图片
    delCertificationUrls(item) {
      this.formData.certificationUrls = this.formData.certificationUrls.filter(v => v.url != item.url)
    },
    handleReUpload(name) {
      this.$refs[name].chooseFile();
    },
    handleBack(type = 1) {
      this.$emit('handleChangeShow', type)
    },
    // 提交
    async onSubmit(values) {
      if (this.formData.officialWebsite) {
        const websiteRegex = /^(http:\/\/|https:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?(\/\S*)?$/;

        if (!websiteRegex.test(this.formData.officialWebsite)) {
          this.officialWebsiteError = "请输入正确格式官网";
          return false
        } else {
          this.officialWebsiteError = "";
        }
      }
      if (this.formData.email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(this.formData.email)) {
          this.emailError = "请输入正确格式邮箱";
          return false
        } else {
          this.emailError = "";
        }
      }
      this.$refs.form
          .validate()
          .then(() => {
            let studioAvatar = this.formData.studioAvatar.map((item) => {
              return item.url
            })
            let studioWechatQrCode = this.formData.studioWechatQrCode.map((item) => {
              return item.url
            })
            let certificationUrls = this.formData.certificationUrls?.map((item) => {
              return item.url
            })
            let params = {
              ...this.formData,
              studioAvatar: studioAvatar.toString(),
              studioWechatQrCode: studioWechatQrCode.toString(),
              certificationUrls: certificationUrls?.toString(),
              type: 1
            }
            updateStudioInfo(params).then(res => {
              if (res.code === 0) {
                this.$notify({type: 'success', message: '修改成功'})
                this.handleBack(2)
              }
            })
          })
          .catch((err) => {
            console.log(err);
          });
    },

  },
  created() {
  },
  mounted() {
    this.month = formatTime(new Date()).format('YYYY-MM');
    this.init(this.studioId)
  },
}
</script>
<style lang="scss" scoped>
.edit_studioInfo_box {
  min-height: 100%;
  background: #fff;
  padding-bottom: 80px;

  .submit_box {
    width: 100%;
    background: #fff;
    position: fixed;
    bottom: 0px;
    box-sizing: border-box;
    left: 0;
    padding: 10px;
    display: flex;
    justify-content: center;

    :deep(.van-button) {
      width: 50%;
      height: 44px;
    }
  }

  .van-field {
    font-size: 14px;
  }

  :deep(.van-image) {
    width: 120px;
    height: 120px;
  }

  :deep(.van-uploader__upload) {
    width: 120px;
    height: 120px;
  }

  :deep(.van-uploader__file) {
    width: 120px;
    height: 120px;
  }

  .hide_uploader_icon {
    :deep(.van-uploader__upload) {
      display: none !important;
    }
  }
}

.preview {
  width: 100%;
  height: 100%;
  background: #fff;

  video {
    width: 100%;
    height: 100%;
  }
}

.re_upload_btn {
  position: absolute;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
  text-align: center;
  padding: 4px;
  font-size: 14px;
  box-sizing: border-box;
}


</style>
<style>

</style>